/* Avi The Gem Guy — "Show recently sold" on the Loose Gems collection.
   Sold stones are rendered with .avi-is-sold and hidden by CSS unless <html> has .avi-show-sold.
   The choice is remembered for the browsing session. The element re-syncs itself when filters re-render the toolbar. */
(() => {
  const KEY = 'avi-show-sold';
  const read = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const write = (on) => { try { sessionStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {} };
  const apply = (on) => document.documentElement.classList.toggle('avi-show-sold', on);

  apply(read());

  if (customElements.get('avi-sold-toggle')) return;
  customElements.define('avi-sold-toggle', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-avi-show-sold]');
      if (!input) return;
      input.checked = read();
      input.addEventListener('change', () => {
        write(input.checked);
        apply(input.checked);
      });
    }
  });
})();
